<template lang="pug">
	v-list
		v-subheader Boleto
		v-list-tile(v-for='tile in tiles' :key='tile.title')
			v-list-tile-avatar
				v-avatar(size='32px' tile='')
					img(:src='`https://cdn.vuetifyjs.com/images/bottom-sheets/${tile.img}`' :alt='tile.title')
			v-list-tile-title {{ tile.title }}

</template>


<script>
  export default {
    props:["sheet"],
    data: () => ({
      tiles: [
        { img: 'keep.png', title: 'Keep' },
        { img: 'inbox.png', title: 'Inbox' },
        { img: 'hangouts.png', title: 'Hangouts' },
        { img: 'messenger.png', title: 'Messenger' },
        { img: 'google.png', title: 'Google+' }
      ]
    })
  }
</script>





// WEBPACK FOOTER //
// src/components/user/modais/Boleto.vue